import {
  Box,
  Button,
  Divider,
  OutlinedInput,
  InputLabel,
  IconButton,
  InputAdornment,
  FormControl,
  FormHelperText,
  Grid,
  Select,
  MenuItem,
} from "@mui/material";
import { useCallback, useEffect, useState, useRef } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { onlyEmailAddr } from "assets/js/common";

export default function Email(props) {
  const {
    register,
    handleSubmit,
    watch,
    control,
    setError,
    clearErrors,
    setValue,
    getValues,
    reset,
    trigger,
    formState: { errors, submitCount },
  } = useFormContext({
    defaultValues: {
      email: "", // 이메일
      emailAddr: "",
      emailStr: "",
    },
  });

  watch("email", false);
  watch("emailAddr", false);
  watch("emailStr", false);

  const checkEmailValid = () => {
    let pattern = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/;

    let email = watch("email");

    if (email) {
      if (watch("emailAddr")) {
        email += "@" + watch("emailAddr");
      } else if (watch("emailStr")) {
        email += "@" + watch("emailStr");
      }
      return pattern.test(email);
    } else {
      return true;
    }
  };

  const emailType = ["naver.com", "hanmail.net", "gmail.com", "yahoo.co.kr"];

  const existEmailTp = (addr) => {
    return emailType.includes(addr);
  };

  const onReset = () => {
    reset({
      email: "", // 이메일
      emailAddr: "",
      emailStr: "",
    });
  };

  useEffect(() => {
    setValue("email", onlyEmailAddr(getValues("email")), {
      shouldValidate: submitCount > 0,
    });
  }, [watch("email")]);

  useEffect(() => {
    if (existEmailTp(getValues("emailAddr"))) {
      setValue("emailStr", "", {
        shouldValidate: submitCount > 0,
      });
    } else {
      setValue("emailAddr", "");
    }
  }, [watch("emailAddr")]);

  useEffect(() => {
    console.log("emailStr", watch("emailStr"));
    setValue("emailStr", onlyEmailAddr(getValues("emailStr")), {
      shouldValidate: submitCount > 0,
    });
  }, [watch("emailStr")]);

  useEffect(() => {
    // onReset();
  }, []);

  return (
    <>
      <InputLabel>이메일</InputLabel>
      <Grid container spacing={1} className="inner-grid">
        <Grid item xs={12}>
          <Grid
            container
            spacing={1}
            className="item-grid emailForm"
            style={{ alignItems: "start" }}
          >
            <Grid item xs={6}>
              <OutlinedInput
                type="text"
                {...register("email", {
                  // required: true,
                  validate: (val) => {
                    return checkEmailValid();
                  },
                })}
                autoComplete="off"
              />
            </Grid>
            <Grid
              item
              xs={1}
              style={{ paddingLeft: "8px", paddingTop: "19px" }}
            >
              <span className="color-disabled">@</span>
            </Grid>
            <Grid item xs={5}>
              <Controller
                name="emailAddr"
                rules={{
                  validate: (val) => {
                    return checkEmailValid();
                  },
                }}
                control={control}
                render={({ field }) => (
                  <Select id="emailAddr" {...field} displayEmpty>
                    <MenuItem value="">직접입력</MenuItem>
                    {emailType.map((type) => (
                      <MenuItem value={type}>{type}</MenuItem>
                    ))}
                  </Select>
                )}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <OutlinedInput
            id="emailStr"
            name="emailStr"
            type="text"
            placeholder="직접입력"
            {...register("emailStr", {
              validate: (val) => {
                return checkEmailValid();
              },
            })}
            aria-describedby="error-email"
            disabled={existEmailTp(getValues("emailAddr"))}
          />

          {/* {errors.email?.type === "required" && (
            <FormHelperText id="error-email" className="error">
              이메일을 입력해주세요.
            </FormHelperText>
          )} */}
          {errors.email?.type === "validate" &&
            errors.emailAddr?.type === "validate" &&
            errors.emailStr?.type === "validate" && (
              <FormHelperText
                id="error-email"
                className="error"
                style={{ marginTop: "6px" }}
              >
                이메일 형식에 맞게 입력해주세요.
              </FormHelperText>
            )}
        </Grid>
      </Grid>
    </>
  );
}
